import { Link } from "react-router-dom";
import { IMG } from "../../data/site";

// Studio logo — supplied A&H circular monogram. Rendered as a circular badge
// so the charcoal artwork reads cleanly on both light and dark headers.
export const Wordmark = ({ className = "", h = "h-11 md:h-14" }) => (
  <span className={`inline-flex items-center select-none ${className}`}>
    <img
      src={IMG.logo}
      alt="Arc & Hollow"
      className={`${h} w-auto aspect-square object-cover rounded-full`}
    />
  </span>
);

// Sharp-edged button, primary/secondary/ghost, works as Link or button.
export const ArcButton = ({
  children,
  to,
  href,
  variant = "primary",
  onDark = false,
  className = "",
  ...rest
}) => {
  const base =
    "inline-flex items-center justify-center gap-3 rounded-none px-8 py-4 text-xs uppercase tracking-overline font-semibold transition-colors duration-500 active:scale-[0.98]";
  const variants = {
    primary: onDark
      ? "bg-chalk text-charcoal hover:bg-bronze hover:text-chalk"
      : "bg-charcoal text-chalk hover:bg-bronze hover:text-chalk",
    outline: onDark
      ? "border border-chalk/40 text-chalk hover:bg-chalk hover:text-charcoal"
      : "border border-charcoal/40 text-charcoal hover:bg-charcoal hover:text-chalk",
    ghost: onDark
      ? "text-chalk hover:text-bronze"
      : "text-charcoal hover:text-bronze",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};
